import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { Grid } from "@material-ui/core";
import ABMLayout from "@icarius-common/abmComponents/abmLayout";
import paths from "@icarius-router/paths";
import { getAdvancesSettingsAction } from "../actions";
import { getLoading, getPermissions, getTypes, getEmployeesList } from "../selectors";
import { RESET_STATE } from "../actionTypes";
import Item from "./publication/item";
import useIsSocietyCountry from "@icarius-app/components/wrapper/hooks/useIsSocietyCountry";

const AdvancesSettings = ({ history }) => {
    const [createIsOpen, setCreateIsOpen] = useState(false);

    const dispatch = useDispatch();
    const isPeru = useIsSocietyCountry("PE");

    const data = useSelector(getPermissions);
    const types = useSelector(getTypes);
    const employeesList = useSelector(getEmployeesList);
    const isLoading = useSelector(getLoading);

    useEffect(() => {
        dispatch(getAdvancesSettingsAction());
        return () => {
            dispatch({ type: RESET_STATE });
        };
    }, [dispatch]);

    const getDataIsEmpty = () => {
        return !data || data.length === 0;
    };

    const handleGoBack = () => {
        history.push(paths.requestsSettings);
    };

    return (
        <ABMLayout
            title={getLocalizedString(isPeru ? "advanceOrAdvancedPaymentSettings" : "advancesSettings")}
            isLoading={isLoading}
            showCreateButton={!createIsOpen}
            createButtonTitle={getLocalizedString(isPeru ? "advanceOrAdvancedPaymentNew" : "newAdvance")}
            createButtonOnClick={() => setCreateIsOpen(true)}
            showNoData={getDataIsEmpty()}
            noDataTitle={getLocalizedString(isPeru ? "noAdvancesOrAdvancedPayment" : "noAdvances")}
            noDataCreateTitle={getLocalizedString(isPeru ? "advanceOrAdvancedPaymentNew" : "newAdvance")}
            noDataOnClick={() => setCreateIsOpen(true)}
            showGoBack
            handleGoBack={handleGoBack}
        >
            <Grid container item xs={12} direction="row">
                {createIsOpen && (
                    <Grid container item xs={12} style={{ margin: "10px 0px" }}>
                        <Item
                            data={null}
                            types={types}
                            employeesList={employeesList}
                            closeCreate={() => setCreateIsOpen(false)}
                        />
                    </Grid>
                )}
                {data &&
                    data.map((item) => {
                        return (
                            <Grid container item xs={12} style={{ margin: "10px 0px" }} key={item.internalCode}>
                                <Item data={item} types={types} employeesList={employeesList} />
                            </Grid>
                        );
                    })}
            </Grid>
        </ABMLayout>
    );
};

export default AdvancesSettings;
